import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true, // enables httpOnly cookies
});

// --- QUEUE LOGIC VARIABLES ---
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  failedQueue = [];
};

// Response Interceptor
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Catch access denied error
    if (error.response?.status === 403) {
      console.error(
        "Error you are not authorized for this function!" +
          error.response?.data?.message,
      );
      return Promise.reject(error);
    } else if (error.response?.status === 400) {
      // Catch bad request error
      console.error(
        "Error! Bad request. Invalid user input\n" +
          error.response?.data?.message,
      );
      return Promise.reject(error);
    } else if (error.response?.status === 409) {
      // this will catch the conflict error.  trying to create an object that already exists in DB
      console.error(
        "Conflict Error! Object already exists in database. \n" +
          error.response?.data?.message,
      );
      return Promise.reject(error);
    } else if (error.response?.status === 404) {
      // handles 404 not found error
      console.error(
        "Object not found in database!\n" + error.response?.data?.message,
      );
      return Promise.reject(error);
    } else if (error.response?.status === 500) {
      // This catches Internal Server Error (usually a NPE or some other error thrown by backend)
      console.error("Internal server error \n" + error.response?.data?.message);
      return Promise.reject(error);

      // 401 unauthorized / token refresh
    } else if (error.response?.status === 401 && !originalRequest._retry) {
      console.log("Access Token expired. Attempting to refresh...");

      // If already refreshing, return a Promise that resolves
      // only when processQueue is called
      if (isRefreshing) {
        console.log("Refresh already in progress. Queueing request...");
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => API(originalRequest))
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Call refresh endpoint using standard axios instance (with credentials)
        // Browser attaches the 'refreshToken' HttpOnly cookie automatically
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/auth/refresh`,
          {},
          { withCredentials: true },
        );

        if (res.status === 200) {
          console.log(
            "Token refreshed successfully! Retrying original request...",
          );
          // Release the waiting requests
          processQueue(null);

          return API(originalRequest);
        }
      } catch (refreshError) {
        console.error(
          "Refresh Token expired or invalid. Redirecting to login.",
        );
        // If refresh fails redirect ot login
        processQueue(refreshError);

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  },
);

export default API;
